// extracted by mini-css-extract-plugin
export default {"line":"hKXDFO","shimmer":"FXeB2U","square":"LhgYVE","paymentMethodContainer":"UTnWJh","paymentMethodRow":"LGPfb2","paymentMethod":"RammuR"};